import { WorkflowEventTriggerType } from 'shared/types/graphql';
import { childAutomationEventTypes } from '../state/utils/draft';
import { AutomationType } from '../types/AutomationDraft';

export interface UseIsChildAutomationProps {
  triggerType: WorkflowEventTriggerType;
  automationType: AutomationType | null;
}

export const getIsChildAutomation = ({ triggerType, automationType }: UseIsChildAutomationProps): boolean => {
  if (!automationType) return false;

  return childAutomationEventTypes.includes(automationType) && triggerType === WorkflowEventTriggerType.Manual;
};

export const useIsChildAutomation = ({ triggerType, automationType }: UseIsChildAutomationProps): boolean => {
  return getIsChildAutomation({ triggerType, automationType });
};
